import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";

import BulkUploadPopup from "../../components/BulkUploadPopup";
import { useLanguage } from "../../context/languageContext";
import { splitList } from "../../helper/listSeparator";

const COLLECTION_VALIDATION_RULES = [
    { field: 'title', type: 'string', message: 'Title is required' },
    { field: 'books', type: 'array', message: 'Book names are required' },
    { field: 'genres', type: 'array', message: 'Genre names are required' },
    { field: 'description', type: 'string', message: 'Description is required' },
];

const COLLECTION_COLUMNS = [
    { key: 'title', label: 'Collection Name' },
    { key: 'books', label: 'Book Names' },
    { key: 'genres', label: 'Genre Names' },
    { key: 'description', label: 'Description' },
];

const BulkUploadCollection = (props) => {
    const { isPopupVisible, handleClosePopup, onSuccess } = props;
    const { adminInfo } = useLanguage();

    const [loading, setLoading] = useState(false);
    // Several values in one cell are separated by ";" — a comma belongs to the
    // value ("Martin Luther King, Jr.", "Everyone Communicates, Few Connect").
    const parseListCell = splitList;

    const createBookObjects = (books) => books.map((book) => ({ bookName: book }));
    const createGenreObjects = (genres) => genres.map((genre) => ({ genreName: genre }));

    const transformedRowValues = (row) => ({
        title: row.title?.trim() || "",
        description: row.description?.trim() || "",
        books: createBookObjects(parseListCell(row.books)),
        genres: createGenreObjects(parseListCell(row.genres)),
    });

    const getTableRowValues = (value) => (
        <>
            <td className="max_width">{value.title}</td>
            <td className="max_width">
                {value.books?.map((item, index) => (
                    <li className="list_styled" key={index}>{item.bookName}</li>
                ))}
            </td>
            <td className="max_width">
                {value.genres?.map((item, index) => (
                    <li className="list_styled" key={index}>{item.genreName}</li>
                ))}
            </td>
            <td className="max_width">{value.description}</td>
        </>
    );

    const handleAddCollectionData = async (values) => {
        setLoading(true);
        try {
            if (values.length >= 50) {
                toast.info("You can only add up to 50 collections at a time");
                setLoading(false);
                return;
            };

            const headers = { Authorization: `Bearer ${adminInfo.token}` };
            const { data: response } = await axios.post(`${process.env.REACT_APP_API_ROOT}/api/admin/collection/bulk-add`, { values }, { headers });

            if (response.status === true) {
                toast.success(response.message);
                handleClosePopup();
                onSuccess();
            } else {
                toast.error(response.message);
            }
        } catch (error) {
            console.error("handleAddCollectionData catch error::", error);
            const errorMessage = error.response?.data?.message || error.response?.data?.error;
            toast.error(errorMessage);
        } finally {
            setTimeout(() => setLoading(false), 300);
        }
    };


    return (
        <BulkUploadPopup
            isPopupVisible={isPopupVisible}
            handleClosePopup={handleClosePopup}
            title="Add Collections in Bulk through CSV"
            columns={COLLECTION_COLUMNS}
            validationRules={COLLECTION_VALIDATION_RULES}
            transformedRowValues={transformedRowValues}
            getTableRowValues={getTableRowValues}
            onSubmit={handleAddCollectionData}
            label="Collections"
            isSubmit={loading}
        />
    );
};

export default BulkUploadCollection;
